import { useCallback, useState } from "react";

import { detectOSAndBrowser } from "@smart/itops-utils-basic";

import { intakeApi } from "./api";

export type IntakeTrackEvent = {
  category: "track";
  name?: string | null;
  screen?: string | null;
  entryPoint?: string | null;
  component?: string | null;
  jiraKey?: string | null;
  interactionType?: "Active" | "Passive";
  properties?: Record<string, unknown>;
};

export const useSubmissionAnalytics = (submissionId: string) => {
  const { post: postAnalyticsEvent } = intakeApi.analyticsEvent();
  const [sessionId] = useState(() => Date.now().toString());

  const postEvent = useCallback(
    (event: IntakeTrackEvent | { category: "identify" }) => {
      const { os, browser } = detectOSAndBrowser(navigator.userAgent);
      postAnalyticsEvent({
        body: {
          id: submissionId,
          eventDateTime: Date.now(),
          sessionId,
          browserType: browser,
          operatingSystem: os,
          platform: "Web",
          event,
        },
      }).catch(console.error);
    },
    [postAnalyticsEvent, sessionId, submissionId],
  );

  const postTrackEvent = useCallback(
    (event: IntakeTrackEvent) => postEvent(event),
    [postEvent],
  );

  const postIdentifyEvent = useCallback(
    () => postEvent({ category: "identify" }),
    [postEvent],
  );

  return { sessionId, postTrackEvent, postIdentifyEvent };
};
